export default Object.freeze({
    storageKey: {
        keyPrefix: "seatbooking.",
        //sid: "sid",
        mode: "mode",
        searchResults: "searchResults",
        selectedArea: "selectedArea",
        preCasAuthState: "preCasAuthState",
        selectedBooking: "selectedBooking",
        locationInfoQrCode: "locationInfoQrCode",
        locationInfoGps: "locationInfoGps"
    },
    mode: {
        OffsiteMode: "OffsiteMode",
        OnsiteModeGps: "OnsiteModeGps",
        OnsiteModeQrCode: "OnsiteModeQrCode"
    },
    channelId: {
        SMS: "SMS",
        Email: "Email"
    },
    accountType: {
        EmailLoginUser: "EmailLoginUser",
        MobileLoginUser: "MobileLoginUser"
    },
    defaultBranchName: "National Library Board"
})